import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import { Badge, Button, Card, CardBody, Col, Container, Input, Row, Table } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import RestrictModal from "./RestrictModal"
import {
  getPlatformUsers,
  restrictPlatformUser,
  unrestrictPlatformUser,
} from "../../store/PlatformAdmin/actions"

const formatDate = value => (value ? new Date(value).toLocaleDateString("es-MX") : "")

const PlatformUsersList = () => {
  const dispatch = useDispatch()
  const users = useSelector(state => state.PlatformAdminReducer.users)

  const [search, setSearch] = useState("")
  const [selectedUser, setSelectedUser] = useState(null)
  const [isRestrictOpen, setIsRestrictOpen] = useState(false)

  // Solo el dueño ve esta pantalla; el backend lo valida de todas formas
  const authUser = JSON.parse(sessionStorage.getItem("authUser") || "null")
  const isOwner = !!authUser?.is_platform_owner

  useEffect(() => {
    if (isOwner) dispatch(getPlatformUsers())
  }, [])

  const filteredUsers = useMemo(() => {
    const term = search.trim().toLowerCase()
    if (!term) return users
    return users.filter(
      u => u.name?.toLowerCase().includes(term) || u.email?.toLowerCase().includes(term)
    )
  }, [users, search])

  if (!isOwner) {
    return <Navigate to="/dashboard" replace />
  }

  const openRestrict = user => {
    setSelectedUser(user)
    setIsRestrictOpen(true)
  }

  const handleUnrestrict = user => {
    if (window.confirm(`¿Quitar la restricción a ${user.name}?`)) {
      dispatch(unrestrictPlatformUser({ user_id: user.id }))
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Administración" breadcrumbItem="Usuarios" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Input
                    className="mb-3"
                    placeholder="Buscar por nombre o email"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                  />
                  <div className="table-responsive">
                    <Table className="table-striped align-middle mb-0">
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Email</th>
                          <th>Estado</th>
                          <th>Motivo</th>
                          <th>Fecha</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredUsers.map(user => (
                          <tr key={user.id}>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>
                              {user.is_platform_owner ? (
                                <Badge color="info">Dueño</Badge>
                              ) : user.restricted_at ? (
                                <Badge color="danger">Restringido</Badge>
                              ) : (
                                <Badge color="success">Activo</Badge>
                              )}
                            </td>
                            <td>{user.restriction_reason || ""}</td>
                            <td>{formatDate(user.restricted_at)}</td>
                            <td className="text-end">
                              {!user.is_platform_owner && (user.restricted_at ? (
                                <Button size="sm" color="success" onClick={() => handleUnrestrict(user)}>
                                  Quitar restricción
                                </Button>
                              ) : (
                                <Button size="sm" color="danger" onClick={() => openRestrict(user)}>
                                  Restringir
                                </Button>
                              ))}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <RestrictModal
            isOpen={isRestrictOpen}
            toggle={() => setIsRestrictOpen(!isRestrictOpen)}
            user={selectedUser}
            onConfirm={payload => dispatch(restrictPlatformUser(payload))}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PlatformUsersList
